export default "__VITE_ASSET__DAHH8XiH__"